export const BACKENDS = [
  "ODP 1.0",
  "ODP 1.5",
  "MBB 1.5",
  "Service Platform",
];

export const BRANDS = [
  "Audi",
  "Bentley",
  "Lamborghini",
  "Porsche",
  "Seat",
  "Cupra",
  "Skoda",
  "Volkswagen",
  "VW Volkswagen NFZ (Commercial vehicles)",
  "Ford",
  "MAN"
];

export const VEHICLES = [
  "MOD 1",
  "MOD 2",
  "MOD 2.5",
  "MOD 3",
  "MOD 3.5",
  "MOD 4",
  "MOD3.6(PPE)",
  "MOD 4.1",
  "MOD 4.2",
];

export const MARKETS = [
  "Europe",
  "America",
  "China",
  "RoW"
];

export const MODULES = [
  "MBB Infrastructure",
  "ODP Infrastructure",
  "Mobile Network Operator",
  "Mobile Service Gateway",
  "73794_SUU_DPD",
  "74384_SUU_CCG",
  "760_MBBS_CMSA",
  "761_MBBS_CMSP",
  "83716_CCP",
  "83723_GDC_Master",
  "83724_GDC_Order Management",
  "83788_ODC",
  "83789_CCS",
  "857_SOKO",
  "85801_MBBC_DISP",
  "85805_MBBC_MGMT",
  "85811_MBBC_LOGACC",
  "85813_MBBC_CAI",
  "85814_MBBC_FITNS",
  "85815_MBBC_FITLUP",
  "85816_MBBC_OAUTH",
  "85819_MBBC_ATIME",
  "85820_MBBC_CSP",
  "85821_MBBC_OBD",
  "85822_MBBC_REG",
  "85823_MBBC_3GPLUS",
  "85824_MBBC_CLSEL",
  "85826_MBBC_PRS",
  "85827_MBBC_MOCKS",
  "85829_MBBC_ENROLL",
  "85830_MBBC_PWCONF",
  "85831_MBBC_TSMS",
  "85832_MBBC_PSEUDO",
  "85834_MBBC_FLEET",
  "85837_MBBC_SPIN",
  "85838_MBBC_USERMGMT",
  "85839_MBBC_MADS",
  "85840_MBBC_MDS",
  "85841_MBBC_VDS",
  "85842_MBBC_FOD",
  "85844_MBBC_SIMMGMT",
  "85845_MBBC_XGW",
  "85901_MBBS_SPEECH",
  "85902_MBBS_MENUE",
  "85903_MBBS_CCSS",
  "85904_MBBS_TSS",
  "85904_MBBS_TSS c103073",
  "85905_MBBS_APPLST",
  "85907_MBBS_APPREP",
  "85909_MBBS_FNS",
  "8590901_MBBS_FNSADAPTER",
  "85911_MBBS_DPC",
  "85912_MBBS_LSCREE",
  "85915_MBBS_OKVS",
  "85916_MBBS_MNP",
  "8591601_MBBS_MNP_SD",
  "8591602_MBBS_MNP_UNP",
  "8591603_MBBS_MNP_ADM",
  "8591604_MBBS_MNP_PS",
  "8591605_MBBS_MNP_MQNP",
  "8591606_MBBS_MNP_BPP",
  "8591607_MBBS_MNP_EP",
  "8591608_MBBS_MNP_PP",
  "8591609_MBBS_MNP_PLI",
  "8591611_MBBS_MNP_PNS",
  "8591612_MBBS_MNP_JP_ADAPTER",
  "8591613_MBBS_MNP_VP",
  "8591614_MBBS_MNP_CS",
  "85917_MBBS_IMGSCL",
  "85918_MBBS_DSGVO",
  "85919_MBBS_MDM",
  "85994_MBBB_STOCMS",
  "86001_MBBB_PROFIL",
  "86002_MBBB_ECHO",
  "86004_MBBB_PICNAV",
  "86005_MBBB_WETTER",
  "86006_MBBB_REISE",
  "86007_MBBB_NEWS",
  "86008_MBBB_FPI",
  "86009_MBBB_TWIT",
  "86010_MBBB_TRAIN",
  "86012_MBBB_CITYEV",
  "86014_MBBB_PARK",
  "86017_MBBB_COUNTR",
  "86021_MBBB_FLIGHT",
  "86023_MBBB_DISCL",
  "86024_MBBB_POI",
  "86025_MBBB_DESTIM",
  "86026_MBBB_TRAFFIC",
  "86028_MBBB_RBC",
  "86029_MBBB_RPC",
  "86030_MBBB_RDT",
  "86031_MBBB_RTS",
  "86034_MBBB_OTV",
  "86035_MBBB_OPR",
  "86036_MBBB_VSR",
  "86037_MBBB_CF",
  "86039_MBBB_RS",
  "86040_MBBB_RLU",
  "86042_MBBB_PPOI",
  "86042_MBBB_PPOI SD",
  "86043_MBBB_VHR",
  "86045_MBBB_PRSPOI",
  "86046_MBBB_RUSM",
  "86047_MBBB_GEOFEN",
  "86048_MBBB_SPEEDA",
  "86049_MBBB_VALETA",
  "86050_MBBB_RVT",
  "86051_MBBB_DWA",
  "86052_MBBB_ECALL",
  "86053_MBBB_RHF",
  "86054_MBBB_EFPI",
  "86054_MBBB_FPI",
  "86055_MBBB_RORE",
  "86056_MBBB_TRVI",
  "86057_MBBB_DEEV",
  "86058_MBBB_CALLCC",
  "86059_MBBB_BUNCON",
  "86060_MBBB_AIO",
  "86061_MBBB_MOBKEY",
  "86062_MBBB_CONRAD",
  "86063_MBBB_ONUP",
  "86064_MBBB_TDISP",
  "86065_MBBB_VTS",
  "86066_MBBB_MVS",
  "86067_MBBB_MVSGEO",
  "86069_MBBB_CTS",
  "86071_MBBB_POIAG",
  "860710_MBBB_POIAG",
  "8607101_MBBB_POIAG",
  "8607102_MBBB_DBSrchEce",
  "8607103_MBBB_NavDbEce",
  "8607104_MBBB_DBSrchNar",
  "8607105_MBBB_NavDBNar",
  "8607106_MBBB_DBSrchRdw",
  "8607107_MBBB_NavDBRdw",
  "8607108_MBBB_DBSRECM3",
  "8607109_MBBB_NVDBECM3",
  "8607110_MBBB_DBSRNAM3",
  "8607111_MBBB_NVDBNAM3",
  "8607112_MBBB_DBSRRDM3",
  "8607113_MBBB_NVDBRDM3",
  "86072_MBBB_TDISP2",
  "86075_MBBB_TESTAP",
  "86076_MBBB_STSTC",
  "86077_MBBB_TMCS",
  "86082_MBBB_DCCS2",
  "86083_MBBB_PnC",
  "86090_MBBB_RPT",
  "86091_MBBB_PSO",
  "86092_MBBB_BLE",
  "86093_MBBB_PARKPL",
  "86094_MBBB_STO",
  "86101_MBBA_SRVADM",
  "86103_MBBA_PUPADM",
  "86104_MBBA_SPEECH",
  "86108_MBBA_FBDADM",
  "86110_MBBA_OAUTH",
  "86111_MBBA_ONUP",
  "86112_MBBA_RUCM",
  "86114_MBBA_OKVS",
  "86115_MBBA_TSMS",
  "86117_MBBA_PNC",
  "86118_MBBA_PSEUDO",
  "86119_MBBA_CKTOOL",
  "86403_MBBB_RST",
  "86404_MBBB_PCB",
  "865_RUCM",
  "867_CONCAR",
  "869_ACZRSS",
  "870_MQTTBRK",
  "876_SOPVIEWER",
  "879_VKMS",
  "88001_MBBB_DOPI",
  "88004_MBBB_LSCREE",
  "88007_MBBB_NEWS",
  "88011_MBBB_INCASH",
  "88024_MBBB_DISCLMAN",
  "88097_MBBB_ALEXA",
  "88098_MBBB_OSP",
  "88308_MBBB_OLB",
  "88309_MBBB_OBB",
  "88312_MBBB_UPDATE",
  "88313_MBBB_QRLOGIN",
  "88324_MBBB_WLANQR",
  "88393_MBBB_EMOBROUTEPLAN",
  "88394_MBBB_STO",
  "88396_MBBB_EDS",
  "88399_MBBB_CALNDR",
  "88400_MBBB_MOND",
  "88535_DDS",
  "99504_DOA",
  "MOS_ENR_MOD4",
];


export const MAIL_TYPES = ["Critical Event Notification", "Breaking News", "Test Mail"] as const;
export type MailType = typeof MAIL_TYPES[number];

export const STATUS_OPTIONS = [
  { key: "Troubleshooting", color: "#ff0000", bg: "#cc0000" },
  { key: "Fix Implementation", color: "#000000", bg: "#f59e0b" },
  { key: "Resolve", color: "#008000", bg: "#006400" },
  { key: "Change", color: "#808080", bg: "#d3d3d3" },
];

export const canApplyUpdateTag = (status: string): boolean => {
  return status === "Troubleshooting" || status === "Fix Implementation";
};

export const formatStatusWithUpdate = (status: string, includeUpdate?: boolean): string => {
  if (!includeUpdate || !canApplyUpdateTag(status)) return status;
  return `${status} - Update`;
};

// New hierarchical services structure
export interface ServiceCategory {
  parent: string;
  children: string[];
}

export const SERVICES: ServiceCategory[] = [
  {
    parent: "Functions on Demand",
    children: [
      "FoD - Billing address",
      "FoD - Booking history",
      "FoD - Buying process",
      "FoD - Payment information",
      "FoD - Product detail page",
      "FoD - Product display",
      "FoD - Revocation",
      "FoD - Service activation",
      "FoD - Shop"
    ]
  },
  {
    parent: "Infotainment Services",
    children: [
      "Infotainment - 3D city maps",
      "Infotainment - Board book",
      "Infotainment - Calender",
      "Infotainment - Charging_Petrol station",
      "Infotainment - Destination import",
      "Infotainment - Disclaimer",
      "Infotainment - eMail",
      "Infotainment - Fuel Price Information",
      "Infotainment - Hazard alert",
      "Infotainment - InCar Apps",
      "Infotainment – Login",
      "Infotainment - Messages",
      "Infotainment - Online mapupdate",
      "Infotainment - Online news",
      "Infotainment - Online Remote Update",
      "Infotainment - Online voice control",
      "Infotainment - Parking info",
      "Infotainment - Point of interest",
      "Infotainment - Privacy Mode",
      "Infotainment - Routeplanner",
      "Infotainment - RSS Feed",
      "Infotainment - Satellitemaps",
      "Infotainment - Traffic light information",
      "Infotainment - Traffic online",
      "Infotainment - Traffic sign information",
      "Infotainment - Travel Assist with swarm data",
      "Infotainment - Weather"
    ]
  },
  {
    parent: "License",
    children: [
      "Licence - Connect Licence extension",
      "Licence - Status",
      "Licence - Revocation"
    ]
  },
  {
    parent: "MOS APP Services",
    children: [
      "MOS_APP - Abholung",
      "MOS_APP - Additional work",
      "MOS_APP - Add vehicle",
      "MOS_APP - Alexa Skill",
      "MOS_APP - Amazon Music",
      "MOS_APP - Assistant",
      "MOS_APP - Board book",
      "MOS_APP - Contract information",
      "MOS_APP - Cost book",
      "MOS_APP - Create Account",
      "MOS_APP - Delete vehicle",
      "MOS_APP - Digital serviceplan",
      "MOS_APP - Disclaimer",
      "MOS_APP - Equipment details",
      "MOS_APP - Function overview",
      "MOS_APP - Guarantee_Warranty",
      "MOS_APP - Home charging",
      "MOS_APP - Lighting technology",
      "MOS_APP - Login",
      "MOS_APP - Napster",
      "MOS_APP - Notification",
      "MOS_APP - Online Car Care",
      "MOS_APP - PIN",
      "MOS_APP - Privacy_Mode",
      "MOS_APP - Remote Parking",
      "MOS_APP - Routeplanner",
      "MOS_APP - Service appointment history",
      "MOS_APP - Service area",
      "MOS_APP - Servicepartner",
      "MOS_APP - Set as owner",
      "MOS_APP - Tax compliant logbook",
      "MOS_APP - Trip diary",
      "MOS_APP - Usermanagement",
      "MOS_APP - Validation",
      "MOS_APP - Vehicle list",
      "MOS_APP - Vehicle nickname",
      "MOS_APP - Vehicle picture",
      "MOS_APP - Verification"
    ]
  },
  {
    parent: "MOS Portal Services",
    children: [
      "MOS_Portal - Abholung",
      "MOS_Portal - Additional work",
      "MOS_Portal - Add vehicle",
      "MOS_Portal - Amazon Music",
      "MOS_Portal - Board book",
      "MOS_Portal - Contract information",
      "MOS_Portal - Cost book",
      "MOS_Portal - Create Account",
      "MOS_Portal - Delete vehicle",
      "MOS_Portal - Digital serviceplan",
      "MOS_Portal - Digital twin",
      "MOS_Portal - Disclaimer",
      "MOS_Portal - Equipment details",
      "MOS_Portal - Extended vehicle",
      "MOS_Portal - Function overview",
      "MOS_Portal - Guarantee_Warranty",
      "MOS_Portal - Login",
      "MOS_Portal - Mapupdate",
      "MOS_Portal - Napster",
      "MOS_Portal - Notification",
      "MOS_Portal - Privacy_Mode",
      "MOS_Portal - Service appointment history",
      "MOS_Portal - Service area",
      "MOS_Portal - Servicepartner",
      "MOS_Portal - Set as owner",
      "MOS_Portal - Trip diary",
      "MOS_Portal - Usermanagement",
      "MOS_Portal - Validation",
      "MOS_Portal - Vehicle list",
      "MOS_Portal - Vehicle nickname",
      "MOS_Portal - Vehicle picture",
      "MOS_Portal - Verification"
    ]
  },
  {
    parent: "Proactive Services",
    children: [
      "Proactive - Breakdown call",
      "Proactive - Emergency call",
      "Proactive - Enrollment",
      "Proactive - Factory Reset",
      "Proactive - Infocall",
      "Proactive - Secondary User"
    ]
  },
  {
    parent: "Remote Services",
    children: [
      "Remote - Auxiliary heating",
      "Remote - Battery management",
      "Remote - Carfinder",
      "Remote - Charge",
      "Remote - Climatisation",
      "Remote - Concierge Service",
      "Remote - Curfew alert",
      "Remote - Digital Key",
      "Remote - Geofence alert",
      "Remote - Honk and Flash",
      "Remote - Plug and Charge",
      "Remote - Remote lock unlock",
      "Remote - Remote trip statistic",
      "Remote - Service lead",
      "Remote - Smart Charging",
      "Remote - Speed alert",
      "Remote - Stolen vehicle locator"
    ]
  },
  {
    parent: "Streaming Services",
    children: [
      "Streaming - Amazon Music",
      "Streaming - Apple Music",
      "Streaming - Dataplan",
      "Streaming - Napster",
      "Streaming - Tidal",
      "Streaming - Webradio",
      "Streaming - WLAN Hotspot"
    ]
  },
  {
    parent: "Edge Cases",
    children: [
      "Edge Case - App Connect",
      "Edge Case - DataPlug",
      "Edge Case - Miscellaneous - [specific category]",
      "Edge Case - Tools - myAudi Go"
    ]
  },
  {
    parent: "Service Platform",
    children: [
      "Vehicle Connector | VCF - Vehicle Connectivity Framework",
      "Vehicle Connector | VDBS - Vehicle Discovery Backend Service",
      "Vehicle Connector | zFDI - zentraler Fahrzeug Daten Interpreter",
      "Vehicle User Relations & Enrollment | Enrollment Service",
      "Vehicle User Relations & Enrollment | SeLIS - Security Level Information Service",
      "Vehicle User Relations & Enrollment | VAS - Vehicle Activation Service",
      "Vehicle User Relations & Enrollment | VDQS - Verification Data Qualification Service",
      "Vehicle User Relations & Enrollment | VUM - Vehicle User Management"
    ]
  },
  {
    parent: "Data Collection",
    children: [
      "SUU - Statischer Umfelddaten Uploader",
      "GDC - Group Data Collector Order Management",
      "GDC - Group Data Collector Master Extension",
      "CCP - Consent Claims Provider"
    ]
  },
  {
    parent: "Others",
    children: [
      "All connect services",
      "Grey services",
      "All remote services",
      "All colored services",
      "PDE (PreDelivery Enrollment)"
    ]
  },
  {
    parent: "Apps",
    children: [
      "MyVW",
      "BFF",
      "One.App"
    ]
  }
];

export const ServicesShort: string[] = [
  "Car Registration (R&P)",
  "Enrollment and Primary User Nomination",
  "App/Portal/Incar Login",
  "Car2x Remote Services",
  "Electric Vehicle Remote Services",
  "Function on Demand (FoD)",
  "Online Remote Updates",
  "Infotainment Services",
  "App/Portal Garage View",
  "Voice Call (Ecall/Bcall)",
  "Data Platform Applications",
  "Frontend Registration",
  "No Direct Customer Impact"
];
